const Auxiliary = (props) => props.children;

export default Auxiliary;



// WEBPACK FOOTER //
// ./src/flexile/util/Auxiliary.js